import { render, staticRenderFns } from "./ProductColorStockSupplier.vue?vue&type=template&id=6e474cda&scoped=true&"
import script from "./ProductColorStockSupplier.vue?vue&type=script&lang=js&"
export * from "./ProductColorStockSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ProductColorStockSupplier.vue?vue&type=style&index=0&id=6e474cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e474cda",
  null
  
)

export default component.exports